import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

 
import {
  ModuleRegistry,
  ValidationModule,
  RowStyleModule
} from 'ag-grid-community';

// import {
//   RowGroupingModule,
//   PivotModule,
//   ColumnsToolPanelModule,
//   FiltersToolPanelModule,
//   MenuModule,
//   SetFilterModule,
//   ServerSideRowModelApiModule,
//   ServerSideRowModelModule
// } from 'ag-grid-enterprise';

import {
  ServerSideRowModelModule,
  ServerSideRowModelApiModule,
  RowGroupingModule,
  PivotModule,
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  MenuModule,
  SetFilterModule
} from 'ag-grid-enterprise';

import 'ag-grid-enterprise';

// REGISTER MODULES
// ModuleRegistry.registerModules([
//   ServerSideRowModelModule,
//   RowGroupingModule,
//   PivotModule,
//   ColumnsToolPanelModule,
//   FiltersToolPanelModule,
//   MenuModule,
//   SetFilterModule
// ]);

ModuleRegistry.registerModules([
  ValidationModule,
  RowStyleModule,
  ServerSideRowModelModule,
  ServerSideRowModelApiModule,
  RowGroupingModule,
  PivotModule,
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  MenuModule,
  SetFilterModule
]);


bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));